/*
Данные функции добавляют возможность закрыть попап по нажатию кнопки "назад".
Передаваемым параметром является функция закрытия попапа.
addPopupOpenedHistory нужно вставить в функцию инициализации попапа,
removePopupOpenedHistory нужно вставить в функцию закрытия попапа.

Кроме этого возможны ситуации когда нужно управлять сразу несколькими попапами.
Для этого есть функции addAllPopupOpenedHistory и removeAllPopupOpenedHistory.
 */
var listeners = {};
var popupStack = new Set();

function addPopupOpenedHistory(closePopup) {
  window.history.pushState('popup-open', null, '');
  window.addEventListener('popstate', closePopup);
}

function removePopupOpenedHistory(closePopup) {
  if (window.history.state === 'popup-open') {
    window.history.back();
  }

  window.removeEventListener('popstate', closePopup);
}

function addAllPopupOpenedHistory(closePopup, id) {
  window.history.pushState("popup-open-".concat(id), null, '');
  listeners[id] = handleClosePopup.bind(null, closePopup, id);
  popupStack.add(id);
  window.addEventListener('popstate', listeners[id]);
}

function removeAllPopupOpenedHistory(id) {
  if (window.history.state === "popup-open-".concat(id)) {
    window.history.back();
  }

  window.removeEventListener('popstate', listeners[id]);
  popupStack["delete"](id);
  delete listeners[id];
}

function handleClosePopup(closePopup, id, event) {
  if (checkConditionForPopupOpenedHistory(event, id)) {
    closePopup();
    popupStack["delete"](id);
    delete listeners[id];
  }
}

function checkConditionForPopupOpenedHistory(event, id) {
  var isLastOpenedPopup = id === Array.from(popupStack).pop();
  var isNotPreviousPopup = event.state !== "popup-open-".concat(id);
  return isNotPreviousPopup && isLastOpenedPopup;
}

export { addPopupOpenedHistory, removePopupOpenedHistory, addAllPopupOpenedHistory, removeAllPopupOpenedHistory };